import {cn} from '@features/ui/utils';

export const GenerationLoader = ({
  hasClarifyingQuestions = false,
}: {
  hasClarifyingQuestions?: boolean;
}) => {
  return (
    <div className='flex w-full flex-col items-center pt-96'>
      <div
        data-zoom-chrome='generation-loader'
        style={{
          transform: 'scale(var(--inverse-zoom, 1))',
        }}
        className='flex flex-col items-center'
      >
        <p
          className={cn(
            'animate-pulse-text text-sm font-semibold',
            hasClarifyingQuestions
              ? 'text-[var(--orange)]'
              : 'text-[var(--purple)]',
          )}
        >
          {hasClarifyingQuestions ? 'Need clarification' : 'Designing'}
        </p>
      </div>
    </div>
  );
};
